export default __webpack_public_path__ + "static/media/CloseIcon2.890bd52e.svg";